(ns app.front.ui.combo-box
  (:require [clojure.string :as str]
            [core.front.carbon :as cc]
            [potpuri.core :as p]
            [schema-tools.core :as st]))

(defn parse-change [^js evt]
  (-> evt
      .-selectedItem
      (js->clj :keywordize-keys true)))

(defn item-visible? [^js filter-evt]
  (let [{{:keys [label]} :item input :inputValue} (js->clj filter-evt :keywordize-keys true)]
    (or (str/blank? input)
        (str/includes? (str/lower-case label) (str/lower-case input)))))

(defn combo-box
  "Make a combo box component that wraps Carbon ComboBox, allowing easy operation with arbitrary items without doing
  the required JS interop.

  Props are passed through to `cc/combo-box`

  Required
   `:id`, `:tr`, `:items`

  Note that `:item->id` must provide a stable unique id for the item

   `:on-change`, `:value`

  Optional
   `:item->str`       (fn, default `str`)
   `:item->id`        (fn, default `:db/id`), REQUIRED if these do not have `:db/id`, must provide a stable unique id
   `:value`           one of the items, makes this a controlled component.
                      NOTE: the user can still clear the selection, does not guarantee something remains visually selected.
                      NOTE: changing value to `nil` will not clear the component from its current selection
   `:initial-value`   one of the items, set as the initial selection
   `:allow-empty?`    (boolean, default false), controls whether `on-change` is called with `nil` or not
   `:placeholder`     (string, default `(tr [:select-option])`), text displayed when value is `nil`
   `:label-text`      (string, default placeholder text), used as visible or ARIA label
   `:hide-label`      (bool) hide label visually, set it as ARIA label for accessibility
   `:size`            (`:sm`, `:md` or `:lg`, default `:lg`)"
  [{:keys [id
           tr
           on-change
           items
           initial-value
           value
           item->str
           item->id
           allow-empty?
           placeholder
           label-text
           hide-label
           size]
    :as   props
    :or   {allow-empty? false
           hide-label   false
           size         :lg
           item->id     :db/id
           item->str    str}}]
  (let [id+items      (->> items
                           (map (fn [item]
                                  [(item->id item) item])))
        id-item-map   (into {} id+items)
        simple-items  (->> id+items
                           (map (fn [[id item]]
                                  {:id    id
                                   :label (item->str item)})))
        selected-item (when-let [sel-item (or value initial-value)]
                        {:id    (item->id sel-item)
                         :label (item->str sel-item)})
        placeholder   (or placeholder (tr [:select-option]))
        label-text    (or label-text placeholder)]
    (cc/combo-box (-> (merge props
                             (p/assoc-if
                               {:id                 id
                                :on-change          #(when on-change
                                                       (let [{:keys [id]} (parse-change %)]
                                                         (when (or id allow-empty?)
                                                           (on-change (some->> id (get id-item-map))))))
                                :placeholder        (or placeholder (tr [:select-option]))
                                :items              simple-items
                                :should-filter-item item-visible?
                                :size               size}
                               :selected-item (when value selected-item)
                               :initial-selected-item (when initial-value selected-item)
                               :title-text (when-not hide-label label-text)
                               :aria-label (when hide-label label-text)))
                      (st/select-schema cc/ComboBoxOptions)))))
